/**
 * Escolha entre assinar ali na clínica (QR/link na hora) ou receber o link
 * pelo WhatsApp — mesmo visual do wizard de contratos.
 */

import type { ReactNode } from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import PhoneIcon from '@mui/icons-material/PhoneIphoneRounded';

import { DELIVERY_METHOD_HINTS, DELIVERY_METHOD_LABELS } from '../../constants/signature';
import type { DeliveryMethod } from '../../types/signature';

const OPTIONS: Array<{ value: DeliveryMethod; icon: ReactNode }> = [
  { value: 'device', icon: <PhoneIcon fontSize="small" /> },
  { value: 'whatsapp', icon: <WhatsAppIcon fontSize="small" /> },
];

export default function DeliveryMethodPicker({
  value,
  onChange,
}: {
  value: DeliveryMethod;
  onChange: (value: DeliveryMethod) => void;
}) {
  return (
    <Stack direction="row" flexWrap="wrap" gap={1.25}>
      {OPTIONS.map((option) => {
        const selected = value === option.value;
        return (
          <Paper
            key={option.value}
            variant="outlined"
            onClick={() => onChange(option.value)}
            sx={{
              flex: '1 1 200px',
              minWidth: 190,
              p: 1.5,
              borderRadius: 2,
              cursor: 'pointer',
              borderColor: selected ? '#0D9488' : 'divider',
              borderWidth: selected ? 2 : 1,
              bgcolor: selected ? 'rgba(13,148,136,0.05)' : 'background.paper',
              transition: 'border-color 160ms ease, background-color 160ms ease',
              '&:hover': { borderColor: selected ? '#0D9488' : '#94A3B8' },
            }}
          >
            <Stack direction="row" spacing={0.75} alignItems="center">
              <Box sx={{ color: selected ? '#0D9488' : 'text.disabled', display: 'flex' }}>
                {option.icon}
              </Box>
              <Typography sx={{ fontWeight: 600, fontSize: 13.5 }}>
                {DELIVERY_METHOD_LABELS[option.value]}
              </Typography>
            </Stack>
            <Typography sx={{ fontSize: 12, color: 'text.secondary', mt: 0.35, lineHeight: 1.45 }}>
              {DELIVERY_METHOD_HINTS[option.value]}
            </Typography>
          </Paper>
        );
      })}
    </Stack>
  );
}
